import axios from '@/requests';
import { Hardware } from '@/store/modules/hardware/types';

export const hardwareAPI = {
    async getHardwareListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<Hardware[]>('/ComputerInfo/getComputerInfoListByUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getOneComputerInfoListByUidAndTime(projId: string, uid: string, id: number) {
        try {
            const res = await axios.get<Hardware[]>('/ComputerInfo/getOneComputerInfoListByUidAndTime', { "projId": projId, "uid": uid, "id": id });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    }
}